import { SquarePen } from "lucide-react";
import { useTranslation } from "react-i18next";

interface TakeawaysIndicatorTabProps {
  onClick: () => void;
}

const TakeawaysIndicatorTab = ({ onClick }: TakeawaysIndicatorTabProps) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  return (
    <button
      onClick={onClick}
      className={`fixed top-1/2 -translate-y-1/2 z-40 bg-primary text-white px-2 py-4 shadow-md hover:shadow-lg hover:px-2.5 transition-all duration-300 flex flex-col items-center gap-2 cursor-pointer group ${
        isRTL ? 'right-2 rounded-l-md' : 'left-2 rounded-r-md'
      }`}
      aria-label={t("open_takeaways_panel") || "Open takeaways panel"}
    >
      <SquarePen className="w-4 h-4 flex-shrink-0 rotate-90" />
      <div
        className="text-xs font-medium whitespace-nowrap"
        style={{
          writingMode: 'vertical-rl',
          textOrientation: 'mixed'
        }}
      >
        {t("your_takeaways") || "Your Takeaways"}
      </div>
    </button>
  );
};

export default TakeawaysIndicatorTab;
